/**
 * Защита от нежелательных iframe, которые блокируют экран
 * Удаляет iframe с высоким z-index и position: fixed, которые покрывают весь экран
 */

const MAX_Z_INDEX = 2147483647;
const SUSPICIOUS_Z_INDEX_THRESHOLD = 10000; // Порог для подозрительного z-index

/**
 * Проверяет, является ли iframe подозрительным (блокирующим экран)
 */
const isSuspiciousIframe = (iframe) => {
  const style = window.getComputedStyle(iframe);
  const zIndex = parseInt(style.zIndex, 10) || 0;
  const position = style.position;
  const top = style.top;
  const left = style.left;
  const width = style.width;
  const height = style.height;

  // Проверяем признаки блокирующего iframe
  const isFixed = position === 'fixed';
  const isAbsolute = position === 'absolute';
  const coversScreen = 
    (top === '0px' || top === '0') &&
    (left === '0px' || left === '0') &&
    (width === '100%' || width === window.innerWidth + 'px') &&
    (height === '100%' || height === window.innerHeight + 'px');
  
  const hasHighZIndex = zIndex >= SUSPICIOUS_Z_INDEX_THRESHOLD || zIndex === MAX_Z_INDEX;

  return (isFixed || isAbsolute) && coversScreen && hasHighZIndex;
};

/**
 * Удаляет подозрительные iframe
 */
const removeSuspiciousIframes = () => {
  const iframes = document.querySelectorAll('iframe');
  let removedCount = 0;

  iframes.forEach((iframe) => {
    if (isSuspiciousIframe(iframe)) {
      console.warn('Обнаружен подозрительный iframe, удаление...', iframe);
      iframe.remove();
      removedCount++;
    }
  });

  if (removedCount > 0) {
    console.warn(`Удалено ${removedCount} подозрительных iframe`);
  }

  return removedCount;
};

/**
 * Инициализирует защиту от iframe
 */
const initIframeProtection = () => {
  // Удаляем существующие подозрительные iframe сразу
  removeSuspiciousIframes();

  // Наблюдаем за добавлением новых iframe
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'IFRAME' && isSuspiciousIframe(node)) {
          console.warn('Обнаружен новый подозрительный iframe, удаление...', node);
          node.remove();
        }
      });
    });
  });

  // Начинаем наблюдение за изменениями в DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Также периодически проверяем (на случай, если iframe добавляется другим способом)
  const intervalId = setInterval(() => {
    removeSuspiciousIframes();
  }, 1000);

  // Возвращаем функцию для очистки
  return () => {
    observer.disconnect();
    clearInterval(intervalId);
  };
};

export default initIframeProtection;
